import React from "react";

import Navigation from "../components/nounproject-navigation";

class NounProjectContainer extends React.Component {
    render() {
        let navigation = this.renderNavigation();

        return (
            <div>
                {navigation}
                {this.props.children}
            </div>
        );
    }

    renderNavigation() {
        let { noSearch, hideLoginLink } = this.props;

        if (this.props.location.pathname === "/") {
            // if we are on the homepage remove search from the navigation
            noSearch = true;
        }
        return <Navigation noSearch={noSearch} hideLoginLink={hideLoginLink} />;
    }
}

export default NounProjectContainer;
